module.exports = __webpack_public_path__ + "static/media/raymond.8a0a67b1.jpg";